import { BarChart } from '@/common/components/BarChart'
import { ValueChart } from '@/common/components/ValueChart'
import { ChartType } from '@/common/types/chartType'

export const chartComponents = {
  [ChartType.Bar]: BarChart,
  [ChartType.Value]: ValueChart,
}
